import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { LoadScript } from "@react-google-maps/api";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AppThemeProvider } from "./theme";
import { ModalProvider } from "./context/ModalContext";
import { SnackbarProvider } from "./context/SnackbarContext";
import { SocketProvider } from "./context/SocketContext";
import {
  ContextMenuPortal,
  ContextMenuRoot,
} from "./components/ContextMenu/index";
import { store } from "./redux/store";
import reportWebVitals from "./reportWebVitals";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <SnackbarProvider>
          <ModalProvider>
            <LoadScript
              googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ""}
              libraries={["places"]}
            >
              <GoogleOAuthProvider
                clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENTID ?? ""}
              >
                <AppThemeProvider>
                  <SocketProvider>
                    <ContextMenuRoot>
                      <App />
                      <ContextMenuPortal />
                    </ContextMenuRoot>
                  </SocketProvider>
                </AppThemeProvider>
              </GoogleOAuthProvider>
            </LoadScript>
          </ModalProvider>
        </SnackbarProvider>
      </Provider>
    </QueryClientProvider>
  </BrowserRouter>
);

reportWebVitals();